import { render, staticRenderFns } from "./HistorialRecibosVistaDocumentos.vue?vue&type=template&id=6b84f3c8&scoped=true"
import script from "./HistorialRecibosVistaDocumentos.vue?vue&type=script&lang=js"
export * from "./HistorialRecibosVistaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84f3c8",
  null
  
)

export default component.exports